export default __webpack_public_path__ + "static/media/facebook_icon.45e894c4.svg";